import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ 
  selectedCards, 
  onBulkAction, 
  onClearSelection,
  totalCards 
}) => {
  const [showActionsMenu, setShowActionsMenu] = useState(false);

  const bulkActions = [
    {
      id: 'activate',
      label: 'Activate Selected',
      icon: 'CheckCircle',
      color: 'text-success',
      description: 'Activate all selected cards'
    },
    {
      id: 'restrict',
      label: 'Restrict Selected',
      icon: 'XCircle',
      color: 'text-warning',
      description: 'Restrict access for selected cards'
    },
    {
      id: 'deactivate',
      label: 'Deactivate Selected',
      icon: 'MinusCircle',
      color: 'text-error',
      description: 'Deactivate all selected cards'
    },
    {
      id: 'export',
      label: 'Export Selected',
      icon: 'Download',
      color: 'text-accent',
      description: 'Export selected cards data'
    }
  ];

  const handleActionClick = (actionId) => {
    onBulkAction(actionId, selectedCards);
    setShowActionsMenu(false);
  };

  if (selectedCards.length === 0) return null;

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-accent" />
            <span className="font-medium text-text-primary">
              {selectedCards.length} of {totalCards} cards selected
            </span>
          </div>
          
          <Button
            variant="ghost"
            onClick={onClearSelection}
            className="text-sm px-2 py-1 h-auto"
          >
            Clear Selection
          </Button>
        </div>

        <div className="relative">
          <Button
            variant="primary"
            onClick={() => setShowActionsMenu(!showActionsMenu)}
            iconName="ChevronDown"
            iconPosition="right"
          >
            Bulk Actions
          </Button>

          {showActionsMenu && (
            <>
              {/* Backdrop */}
              <div 
                className="fixed inset-0 z-10"
                onClick={() => setShowActionsMenu(false)}
              />
              
              {/* Actions Menu */}
              <div className="absolute right-0 top-full mt-2 w-64 bg-surface border border-border rounded-lg shadow-elevation-3 z-20">
                <div className="p-2">
                  <div className="text-xs font-medium text-text-muted uppercase tracking-wide px-3 py-2">
                    Available Actions
                  </div>
                  {bulkActions.map((action) => (
                    <button
                      key={action.id}
                      onClick={() => handleActionClick(action.id)}
                      className="w-full flex items-center px-3 py-2 text-left hover:bg-hover rounded-lg transition-colors duration-150"
                    >
                      <Icon 
                        name={action.icon} 
                        size={16} 
                        className={`${action.color} mr-3 flex-shrink-0`} 
                      />
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium text-text-primary">
                          {action.label}
                        </div>
                        <div className="text-xs text-text-muted">
                          {action.description}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;